export default __webpack_public_path__ + "static/media/location-line.1adfee04.svg";